import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import merge from 'deepmerge';
import yaml from 'js-yaml';

export interface ITranslationResource {
   prefix: string;
   suffix: string;
}

// based on https://github.com/denniske/ngx-translate-multi-http-loader
export class MultiTranslateHttpLoader implements TranslateLoader {
   constructor(private http: HttpClient, private resources: ITranslationResource[]) {}

   public getTranslation(lang: string): Observable<any> {
      const requests = this.resources
         // don't try to load English Kendo translations, as they are already built-in
         .filter((resource) => resource.prefix.indexOf('kendo') < 0 || lang !== 'en')
         .map((resource) => {
            const path = resource.prefix + lang + resource.suffix;
            return this.http.get(path, { responseType: 'text' }).pipe(
               map((file) => {
                  if (resource.suffix === '.yml') {
                     return yaml.load(file);
                  }
                  return JSON.parse(file);
               }),
               catchError((res) => {
                  console.error('Something went wrong for the following translation file:', path);
                  console.error(res.message);
                  return of({});
               })
            );
         });
      return forkJoin(requests).pipe(map((response) => merge.all(response)));
   }
}
